module.exports = __webpack_public_path__ + "img/5.c244e34f.png";